import {NgModule} from '@angular/core';
import {HourPipe, DayPipe, FullDatePipe, ShortDatePipe, DayMonth, DayHourPipe} from './date.pipe';

@NgModule({
    declarations: [ HourPipe, DayPipe, FullDatePipe, ShortDatePipe, DayMonth, DayHourPipe ],
    exports: [ HourPipe, DayPipe, FullDatePipe, ShortDatePipe, DayMonth, DayHourPipe ]
})
export class DatePipeModule {}
